var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5391 4.15625H2.46094C1.10124 4.15625 0 5.26433 0 6.61719V21.3828C0 22.7437 1.10934 23.8438 2.46094 23.8438H25.5391C26.8874 23.8438 28 22.7484 28 21.3828V6.61719C28 5.26673 26.9031 4.15625 25.5391 4.15625ZM25.1944 5.79688C24.6916 6.29699 16.0389 14.9041 15.7402 15.2013C15.2753 15.6662 14.6573 15.9221 14 15.9221C13.3427 15.9221 12.7247 15.6661 12.2583 15.1998C12.0574 14.9999 3.50016 6.4878 2.80558 5.79688H25.1944ZM1.64062 21.0489V6.95215L8.7302 14.0044L1.64062 21.0489ZM2.80662 22.2031L9.89341 15.1614L11.0998 16.3614C11.8745 17.1361 12.9044 17.5627 14 17.5627C15.0956 17.5627 16.1255 17.1361 16.8987 16.3629L18.1066 15.1614L25.1934 22.2031H2.80662ZM26.3594 21.0489L19.2698 14.0044L26.3594 6.95215V21.0489Z",
    fill: "white"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3f12f06aed111e9bd813693372ddeabf.svg";
export { ForwardRef as ReactComponent };